// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","LoginWelcome":"Hw4IMvK-DNjh","descriptionMsg":"rAkeIHKwa8Z4","welcomeMsg":"_2cSquFxreOj3"};